import React from "react";
import { Removable } from "@planzone/dto";
import { Props } from "./types";
import { ButtonTagForm } from "./buttonTagForm";
import { Tag } from "./tag";
import styles from "./styles.scss";

function TagList({ id, tags, type, project, readOnly }: Props) {
  return (
    <div className={styles.tagList}>
      {!!tags.length ? (
        <div className={styles.list}>
          {tags.map((tag) => (
            <Tag
              key={tag.name}
              tag={tag}
              project={project}
              removable={type as Removable}
              removableId={id}
            />
          ))}
          {!readOnly && (
            <div className={styles.buttonWrapper}>
              <ButtonTagForm
                tags={tags}
                type={type}
                id={id}
                project={project}
              />
            </div>
          )}
        </div>
      ) : (
        !readOnly && (
          <div className={styles.buttonWrapper}>
            <ButtonTagForm tags={tags} type={type} id={id} project={project} />
          </div>
        )
      )}
    </div>
  );
}

export { TagList };
